import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../../shared/api/base-query";
import { pagedQueryFn } from "../../../shared/api/paged-query-fn";
import { CropModel, ICropDto } from "../shared";

export const cropsApiSlice = createApi({
  reducerPath: "api-crops",
  // https://github.com/reduxjs/redux-toolkit/discussions/2347#discussioncomment-2978038
  refetchOnFocus: false,
  keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
  baseQuery,
  tagTypes: ["CropsList"],
  endpoints: (builder) => ({
    cropsList: builder.query<CropModel[], void>({
      queryFn: pagedQueryFn<ICropDto, CropModel[]>({ url: "CropsV2" }, (dtos) =>
        dtos.map((dto) => {
          const model = new CropModel(dto.id);
          model.updateFromDto(dto);
          return model;
        })
      ),
    }),
  }),
});

export const { useCropsListQuery, useLazyCropsListQuery } = cropsApiSlice;
